angular.module('leanlaw').filter("percentage", function () {
  return function (input, showZero) {
    if (!input && showZero === false) return '';
    var val = parseFloat(input);
    if (isNaN(val)) {
      return input;
    }
    return `${val}%`;
  };
});